import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NewsPaginatedResponse } from '../../models/news.model';

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  private readonly API = `https://servicodados.ibge.gov.br/api/v3/noticias/?busca=economia`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<NewsPaginatedResponse> {
    return this.http.get<NewsPaginatedResponse>(`${this.API}`);
  }
}
